<jqxLoader #loader [imagePosition]="'top'" [width]="100" [height]="60" [text]="translate('Procesando')">
</jqxLoader>
<div class="menu-container" #menuContainer>
  <jqxMenu #menu [theme]="environment.tema" [mode]="'vertical'" [width]="'100%'" [height]="'100%'"
    [autoCloseOnMouseLeave]="true" (onItemclick)="onItemClick($event)" style="border: hidden;">
  </jqxMenu>
</div>